import { useT } from "../i18n/useT";
import { useSettings } from "./useSettings";

export function LanguageCard() {
  const t = useT();
  const [s, setS] = useSettings();

  return (
    <div className="settings-card">
      <h3>{t("settings.language")}</h3>
      <div className="muted small">{t("settings.language.hint")}</div>

      <div className="block">
        <div className="segmented">
          <button className={`seg ${s.language === "ru" ? "is-active" : ""}`} onClick={() => setS({ language: "ru" })}>
            RU
          </button>
          <button className={`seg ${s.language === "en" ? "is-active" : ""}`} onClick={() => setS({ language: "en" })}>
            EN
          </button>
          <button className={`seg ${s.language === "kk" ? "is-active" : ""}`} onClick={() => setS({ language: "kk" })}>
            KZ
          </button>
        </div>
      </div>
    </div>
  );
}

